import { mapState, mapActions } from 'vuex'

export const layoutComputed = {
  ...mapState('layout', {
    layoutType: (state) => state.layoutType,
    leftSidebarType: (state) => state.leftSidebarType,
    layoutWidth: (state) => state.layoutWidth,
    topbar: (state) => state.topbar,
    loader: (state) => state.loader
  })
}

export const layoutMethods = mapActions('layout', ['changeLayoutType', 'changeLayoutWidth', 'changeLeftSidebarType', 'changeTopbar', 'changeLoaderValue'])

export const expenseCategoryComputed = { ...mapState('expensecategories', {expensecategories: (state) => state.expensecategories })}
export const expenseCategoryMethods = mapActions('expensecategories', ['fetchExpensecategories'])

export const expenseItemComputed = { ...mapState('expenseitems', {expenseitems: (state) => state.expenseitems })}
export const expenseItemMethods = mapActions('expenseitems', ['fetchExpenseitems'])

export const expenseComputed = { ...mapState('expenses', {expenses: (state) => state.expenses })}
export const expenseMethods = mapActions('expenses', ['fetchExpenses'])

export const expensecartComputed = { ...mapState('expensecarts', {expensecarts: (state) => state.expensecarts })}
export const expensecartMethods = mapActions('expensecarts', ['fetchExpenseCart'])

export const userComputed = { ...mapState('users', {users: (state) => state.users })}
export const userMethods = mapActions('users', ['fetchUsers'])

export const roleComputed = { ...mapState('roles', {roles: (state) => state.roles })}
export const roleMethods = mapActions('roles', ['fetchRoles'])

export const auditComputed = { ...mapState('audits', {audits: (state) => state.audits })}
export const auditMethods = mapActions('audits', ['fetchAudits','filterAudits'])

export const permissionComputed = { ...mapState('permissions', {permissions: (state) => state.permissions })}
export const permissionMethods = mapActions('permissions', ['fetchPermissions'])

export const paymentoptionComputed = { ...mapState('paymentoptions', {paymentoptions: (state) => state.paymentoptions })}
export const paymentoptionMethods = mapActions('paymentoptions', ['fetchPaymentoptions'])

export const productcategoryComputed = { ...mapState('productcategories', {productcategories: (state) => state.productcategories })}
export const productcategoryMethods = mapActions('productcategories', ['fetchCategories'])

export const unitsComputed = { ...mapState('productunits', {productunits: (state) => state.productunits })}
export const unitsMethods = mapActions('productunits', ['fetchUnits'])

export const itemunitsComputed = { ...mapState('productitemunits', {productitemunits: (state) => state.productitemunits })}
export const itemunitsMethods = mapActions('productitemunits', ['fetchItemUnits'])

export const expiredproductComputed = { ...mapState('expiries', {expiries: (state) => state.expiries })}
export const expiredproductMethods = mapActions('expiries', ['fetchExpiredProducts'])

export const productComputed = { ...mapState('products', {products: (state) => state.products })}
export const productMethods = mapActions('products', ['fetchProducts'])

export const purchasecartComputed = { ...mapState('purchasecarts', {purchasecarts: (state) => state.purchasecarts })}
export const purchasecartMethods = mapActions('purchasecarts', ['fetchPurchaseCart'])

export const salecartComputed = { ...mapState('salecarts', {salecarts: (state) => state.salecarts })}
export const salecartMethods = mapActions('salecarts', ['fetchSalesCart'])

export const stocklevelComputed = { ...mapState('stocklevels', {stocklevels: (state) => state.stocklevels })}
export const stocklevelMethods = mapActions('stocklevels', ['fetchStocklevels'])

export const supplierComputed = { ...mapState('suppliers', {suppliers: (state) => state.suppliers })}
export const supplierMethods = mapActions('suppliers', ['fetchSuppliers'])

export const reportpaymentsbyoptionComputed = { ...mapState('reportpaymentsbyoptions', {reportpaymentsbyoptions: (state) => state.reportpaymentsbyoptions })}
export const reportpaymentsbyoptionMethods = mapActions('reportpaymentsbyoptions', ['fetchReportPaymentsbyOptions','filterReportPaymentsbyOptions'])

export const reportpaymentsbymonthComputed = { ...mapState('reportpaymentsbymonths', {reportpaymentsbymonths: (state) => state.reportpaymentsbymonths })}
export const reportpaymentsbymonthMethods = mapActions('reportpaymentsbymonths', ['fetchReportPaymentsbyMonths','filterReportPaymentsbyMonths'])

export const reportserviceanalysisComputed = { ...mapState('reportserviceanalysis', {reportserviceanalysis: (state) => state.reportserviceanalysis })}
export const reportserviceanalysisMethods = mapActions('reportserviceanalysis', ['fetchReportServiceAnalysis','filterReportServiceAnalysis'])

export const reportdiagnosisanalysisComputed = { ...mapState('reportdiagnosisanalysis', {reportdiagnosisanalysis: (state) => state.reportdiagnosisanalysis })}
export const reportdiagnosisanalysisMethods = mapActions('reportdiagnosisanalysis', ['fetchReportDiagnosisAnalysis','filterReportDiagnosisAnalysis'])

export const reportdepartmentanalysisComputed = { ...mapState('reportdepartmentanalysis', {reportdepartmentanalysis: (state) => state.reportdepartmentanalysis })}
export const reportdepartmentanalysisMethods = mapActions('reportdepartmentanalysis', ['fetchReportDepartmentAnalysis','filterReportDepartmentAnalysis'])

export const reportproductsdemandComputed = { ...mapState('reportproductsdemands', {reportproductsdemands: (state) => state.reportproductsdemands })}
export const reportproductsdemandMethods = mapActions('reportproductsdemands', ['fetchReportProductsDemand','filterReportProductsDemand'])

export const reportproductsprofitComputed = { ...mapState('reportproductsprofits', {reportproductsprofits: (state) => state.reportproductsprofits })}
export const reportproductsprofitMethods = mapActions('reportproductsprofits', ['fetchReportProductsProfit','filterReportProductsProfit'])

export const reportcashiersalesComputed = { ...mapState('reportcashiersales', {reportcashiersales: (state) => state.reportcashiersales })}
export const reportcashiersalesMethods = mapActions('reportcashiersales', ['fetchReportCashierSale','filterReportCashierSale'])

export const stocksComputed = { ...mapState('stocks', {stocks: (state) => state.stocks })}
export const stocksMethods = mapActions('stocks', ['fetchStock','filterStock'])

export const reportcashpaymentsComputed = { ...mapState('reportcashpayments', {reportcashpayments: (state) => state.reportcashpayments })}
export const reportcashpaymentsMethods = mapActions('reportcashpayments', ['fetchReportCashPayments','filterReportCashPayments'])

export const reportpersonalpaymentsComputed = { ...mapState('reportpersonalpayments', {reportpersonalpayments: (state) => state.reportpersonalpayments })}
export const reportpersonalpaymentsMethods = mapActions('reportpersonalpayments', ['fetchReportPersonalPayments','filterReportPersonalPayments'])

export const reportpharmacypaymentsComputed = { ...mapState('reportpharmacypayments', {reportpharmacypayments: (state) => state.reportpharmacypayments })}
export const reportpharmacypaymentsMethods = mapActions('reportpharmacypayments', ['fetchReportPharmacyPayments','filterReportPharmacyPayments'])

export const reportpharmacybymonthComputed = { ...mapState('reportpharmacybymonths', {reportpharmacybymonths: (state) => state.reportpharmacybymonths })}
export const reportpharmacybymonthMethods = mapActions('reportpharmacybymonths', ['fetchReportPharmacybyMonths','filterReportPharmacybyMonths'])

export const reportpharmacypurchasesComputed = { ...mapState('reportpharmacypurchases', {reportpharmacypurchases: (state) => state.reportpharmacypurchases })}
export const reportpharmacypurchasesMethods = mapActions('reportpharmacypurchases', ['fetchReportPharmacyPurchases','filterReportPharmacyPurchases'])

export const reportpurchasesbysupplierComputed = { ...mapState('reportpurchasesbysupplier', {reportpurchasesbysupplier: (state) => state.reportpurchasesbysupplier })}
export const reportpurchasesbysupplierMethods = mapActions('reportpurchasesbysupplier', ['fetchReportPurchasesbySupplier','filterReportPurchasesbySupplier'])

export const reportpaymentsbyuserComputed = { ...mapState('reportpaymentsbyuser', {reportpaymentsbyuser: (state) => state.reportpaymentsbyuser })}
export const reportpaymentsbyuserMethods = mapActions('reportpaymentsbyuser', ['fetchReportPaymentsbyUser','filterReportPaymentsbyUser'])

export const reportworkloadbyuserComputed = { ...mapState('reportworkloadbyuser', {reportworkloadbyuser: (state) => state.reportworkloadbyuser })}
export const reportworkloadbyuserMethods = mapActions('reportworkloadbyuser', ['fetchReportWorkloadbyUser','filterReportWorkloadbyUser'])

export const reportlabComputed = { ...mapState('reportlabs', {reportlabs: (state) => state.reportlabs })}
export const reportlabMethods = mapActions('reportlabs', ['fetchReportLab','filterReportLab'])

export const reportappointmentComputed = { ...mapState('reportappointments', {reportappointments: (state) => state.reportappointments })}
export const reportappointmentMethods = mapActions('reportappointments', ['fetchReportAppointment','filterReportAppointment'])

export const reportexpenseComputed = { ...mapState('reportexpenses', {reportexpenses: (state) => state.reportexpenses })}
export const reportexpenseMethods = mapActions('reportexpenses', ['fetchReportExpense','filterReportExpense'])

export const stockreportComputed = { ...mapState('stockreport', {stockreport: (state) => state.stockreport })}
export const stockreportMethods = mapActions('stockreport', ['fetchStockReport','filterStockReport'])

export const reportcashflowComputed = { ...mapState('reportcashflows', {reportcashflows: (state) => state.reportcashflows })}
export const reportcashflowMethods = mapActions('reportcashflows', ['fetchReportCashflow','filterReportCashflow'])

export const reportcashflowsbymonthComputed = { ...mapState('reportcashflowsbymonths', {reportcashflowsbymonths: (state) => state.reportcashflowsbymonths })}
export const reportcashflowsbymonthMethods = mapActions('reportcashflowsbymonths', ['fetchReportCashflowbyMonths','filterReportCashflowbyMonths'])

export const profileComputed = { ...mapState('profiles', {profiles: (state) => state.profiles })}
export const profileMethods = mapActions('profiles', ['fetchProfile'])

export const groupaccountComputed = { ...mapState('groupaccounts', {groupaccounts: (state) => state.groupaccounts })}
export const groupaccountMethods = mapActions('groupaccounts', ['fetchGroupAccounts'])

export const groupaccountmemberComputed = { ...mapState('groupaccountmembers', {groupaccountmembers: (state) => state.groupaccountmembers })}
export const groupaccountmemberMethods = mapActions('groupaccountmembers', ['fetchGroupAccountMembers'])

export const groupaccountinvoiceComputed = { ...mapState('groupaccountinvoices', {groupaccountinvoices: (state) => state.groupaccountinvoices })}
export const groupaccountinvoiceMethods = mapActions('groupaccountinvoices', ['fetchGroupAccountInvoices','filterGroupAccountInvoices'])

export const saleComputed = { ...mapState('sales', {sales: (state) => state.sales})}
export const saleMethods = mapActions('sales', ['fetchSales', 'getSale'])

export const customerComputed = { ...mapState('customers', {customers: (state) => state.customers})}
export const customerMethods = mapActions('customers', ['fetchCustomers'])

export const purchaseComputed = { ...mapState('purchases', {purchases: (state) => state.purchases})}
export const purchaseMethods = mapActions('purchases', ['fetchPurchases'])


export const reportcashiersprofitComputed = { ...mapState('reportcashiersprofits', {reportcashiersprofits: (state) => state.reportcashiersprofits })}
export const reportcashiersprofitMethods = mapActions('reportcashiersprofits', ['fetchReportCashiersProfit','filterReportCashiersProfit'])

export const subscriptionComputed = { ...mapState('subscriptions', {subscriptions: (state) => state.subscriptions })}
export const subscriptionMethods = mapActions('subscriptions', ['fetchSubscriptions'])

export const expiringSoonCountComputed = { ...mapState('expiringSoonCount', {expiringSoonCount: (state) => state.expiringSoonCount})}
export const expiringSoonCountMethods = mapActions('expiringSoonCount', ['fetchExpiringSoonCount'])


export const productsmarginComputed = { ...mapState('productsmargin', {productsmargin: (state) => state.productsmargin })}
export const productsmarginMethods = mapActions('productsmargin', ['fetchProductsMargin','filterProductsMargin'])
